import { convertMmToInchesAndFormat, updateInchValue } from "./mm-inches.js";

(function () {
  const leftPanelCheckbox = jQuery("#left_applied_panel_input");
  const rightPanelCheckbox = jQuery("#right_applied_panel_input");

  const leftRevealInput = jQuery("#left_reveal_input");
  const rightRevealInput = jQuery("#right_reveal_input");

  function handlePanelChange(panelCheckbox, revealInput, formInputSelector) {
    const isChecked = panelCheckbox.is(":checked");
    const value = isChecked ? 3 : 1.5;

    revealInput.val(value).prop("disabled", isChecked);

    const group = jQuery(formInputSelector)[0];
    const output = convertMmToInchesAndFormat(value);
    updateInchValue(group, output);
  }

  leftPanelCheckbox.change(() => handlePanelChange(leftPanelCheckbox, leftRevealInput, '#form_input_left_reveal'));
  rightPanelCheckbox.change(() => handlePanelChange(rightPanelCheckbox, rightRevealInput, '#form_input_right_reveal'));
})();